import { FC, ReactElement } from 'react';

import * as Styles from './docs.module.scss';

export const AnvilMarkdown: FC<{ children: ReactElement }> = ({ children }) => (
    <div className={Styles.markdown}>{children}</div>
);
